import { DeleteForever, PersonAdd, SearchOff } from "@mui/icons-material";
import { Box, Button, IconButton, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableRow, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import AddNewEmailForm from "./AddNewEmailForm";

export const EmailAlertTable: React.FC<IEmailAlertTable> = ({ title, emails, addEmail, removeEmail }) => {
    const [openAddEmailForm, setOpenAddEmailForm] = useState<boolean>(false)

    const openForm = () => {
        setOpenAddEmailForm(true)
    }

    const onCloseForm = () => {
        setOpenAddEmailForm(false)
    }

    const onSubmitEmail = (email: string) => {
        addEmail(email)
        onCloseForm()
    }
    

    return (
        <Paper>
            <Stack
                direction="row"
                spacing={2}
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
                p={2}
            >
                <Box>
                    <Typography variant="h5">{title} Alerts</Typography>
                </Box>
                <Box>
                    <Tooltip title={"Add Email"}>
                        <IconButton onClick={openForm}>
                            <PersonAdd />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Stack>

            <Box height="60vh" sx={{ overflowY: "auto"} }>
                <TableContainer>
                    <Table>
                        <TableBody>
                            {[...emails].sort().map((email) => (
                                <>
                                <TableRow>
                                    <TableCell align="left">
                                        {email}
                                    </TableCell>
                                    <TableCell align="right">
                                        <Button onClick={() => removeEmail(email)}>
                                            <DeleteForever />
                                        </Button>
                                    </TableCell>
                                </TableRow>
                                </>
                            ))}
                            {emails.length === 0 && (
                                <TableRow>
                                    <TableCell align="center" sx={{ border: "none" }}>
                                        <SearchOff fontSize="large" />
                                        <br />
                                        <Typography variant="h6">No Users Found</Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            <AddNewEmailForm open={openAddEmailForm} onClose={onCloseForm} title={title} submitEmail={onSubmitEmail} />
        </Paper>
    );
}


export interface IEmailAlertTable {
    title: string;
    emails: string[];
    addEmail: (email: string) => void;
    removeEmail: (email: string) => void;
}
